export default __webpack_public_path__ + "static/media/transhis.c9bde53e.svg";